import { useState } from 'react'
import { Switch } from '@components/ui/switch'

/**
 * Gradient switch with Colors and Direction swatches. Placeholder UI: the state is local and not
 * applied to the document. Renders a Fragment so its blocks stay direct children of the parent's
 * spacing container.
 */
export function GradientControls({ disabled }: { disabled: boolean }) {
  const [gradient, setGradient] = useState(false)

  return (
    <>
      {/* Gradient */}
      <div className="flex items-center gap-2">
        <Switch checked={gradient} onCheckedChange={setGradient} disabled={disabled} />
        <label className="text-sm font-medium text-foreground leading-none">Gradient</label>
      </div>

      {/* Colors */}
      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-foreground leading-normal">Colors</label>
        <div className="flex gap-2">
          <div className="w-8 h-8 rounded-md border border-border bg-muted"></div>
          <div className="w-8 h-8 rounded-md border border-border bg-muted"></div>
        </div>
      </div>

      {/* Direction */}
      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-foreground leading-normal">Direction</label>
        <div className="grid grid-cols-3 sm:grid-cols-5 gap-1">
          {Array.from({ length: 10 }, (_, i) => (
            <div key={i} className="w-8 h-8 rounded-md border border-border bg-muted"></div>
          ))}
        </div>
      </div>
    </>
  )
}
